// libs
import styled from 'styled-components'
// icons
import CircularProgress from '@mui/material/CircularProgress'

const CircularProgressIcon = styled(CircularProgress)`
  && {
    margin-right: 10px;
    color: white;
  }
`

const CloseButton = styled.div`
  font-weight: bold;
  padding-right: 10px;
  cursor: pointer;
`

export { CircularProgressIcon, CloseButton }
